import React from "react";
import PhoneNumberInput from "components/ui/AppPhoneNumberInput";
import AppInput from "components/ui/AppInput";

/**
 * Renders a login/auth field inside antd Form.Item.
 * Form.Item injects `value` and `onChange`; both must be forwarded or inputs stay stuck (e.g. password).
 */
const FieldRenderer = ({ field, value, onChange }) => {
  if (field.typeKey === "phoneNumber") {
    return (
      <PhoneNumberInput
        label={field.label}
        mandatory={field.required}
        keyVal="phoneNumber"
        value={value}
        placeHolder={field?.placeholder}
        inputProps={{
          autoComplete: "tel",
          placeholder: field?.placeholder,
          countryCallingCodeEditable: true,
          defaultCountry: "",
          countries: [],
          style: {
            height: "56px",
          },
        }}
        handleValues={(_k, v) => {
          onChange?.(v);
        }}
      />
    );
  }

  return (
    <AppInput
      label={field.label}
      mandatory={field.required}
      type={field.type}
      placeholder={field.placeholder}
      value={value}
      onChange={onChange}
      inputProps={{
        autoComplete:
          field.autoComplete ??
          (field.type === "password"
            ? "new-password"
            : field.typeKey === "email"
              ? "email"
              : field.typeKey === "name"
                ? "name"
                : field.typeKey === "code"
                  ? "one-time-code"
                  : "off"),
        name: field.name,
      }}
      inputContainerProps={{
        style: {
          height: "56px",
        },
      }}
    />
  );
};

export default FieldRenderer;